import { createFileRoute } from "@tanstack/react-router";
import { PartsCatalog } from "@/components/tabs/PartsCatalog";

export const Route = createFileRoute("/parts/")({
  component: PartsCatalog,
});
